import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { HeadlineL, HeadlineXS } from '#src/atoms/typography/index.tsx';
import type { Props } from '#src/components/fiatWallet/UnblockWallet/FileUploadStep/index.tsx';
import { FileUploadStep } from '#src/components/fiatWallet/UnblockWallet/FileUploadStep/index.tsx';

const List = styled.ul`
  margin: 0;
  padding-left: var(--triple-unit);

  li {
    list-style-type: disc;
  }
`;

export const BankStatementUpload = (
  props: Omit<Props, 'children' | 'name'>
) => {
  return (
    <FileUploadStep name="bankStatement" {...props}>
      <HeadlineL>
        <FormattedMessage defaultMessage="Upload a bank statement" />
      </HeadlineL>
      <HeadlineXS>
        <FormattedMessage defaultMessage="The bank statement must be dated within the last 3 months. Please ensure that the bank statement you provide includes the following information:" />
      </HeadlineXS>
      <List>
        <li>
          <FormattedMessage defaultMessage="Your full name" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Bank and logo" />
        </li>
        <li>
          <FormattedMessage defaultMessage="Date of issue (no older than 3 months)" />
        </li>
      </List>
    </FileUploadStep>
  );
};
